import { Component, Prop, h } from '@stencil/core';

/**
 * List of social links to display.
 * @type {array}
 * @items.type {object}
 * @items.property {string} type - Social network type (e.g. 'linkedin', 'x', 'dribbble')
 * @items.property {string} href - Link to social profile
 * @items.property {string} label - Accessible label for the link (and visible label if showLabels)
 * @items.required type
 * @items.required href
 * @items.required label
 * @minItems 1
 * @prop {string} [showLabels] - Show text labels next to icons ('true' or 'false')
 */
@Component({
  tag: 'me-socials',
  styleUrl: 'index.scss',
  shadow: false,
})
export class Socials {
  @Prop() items!: any[];
  /** Show text labels next to icons ('true' or 'false') */
  @Prop() showLabels: string = 'false';

  render() {
    return (
      <div class="me-socials">
        {this.items &&
          this.items.map(item =>
            this.showLabels === 'true' ? (
              <div class="me-socials__item-wrapper">
                <me-button
                  class={`me-socials__item me-socials__item--${item.type}`}
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={item.label}
                  variant="ghost"
                  icon={`brands--${item.type}`}
                  iconPosition="before"
                >
                  {item.label}
                </me-button>
              </div>
            ) : (
              <a class={`me-socials__item me-socials__item--${item.type}`} href={item.href} target="_blank" rel="noopener noreferrer" aria-label={item.label}>
                <me-icon name={`brands--${item.type}`} />
              </a>
            ),
          )}
      </div>
    );
  }
}
